/**
 * Icon — Material Symbols Rounded, the design system's icon set.
 *
 * Ported 1:1 from the Tailwind component library:
 * resources/Dental supply storefront design system/tw-components.jsx
 *
 * Deviations from upstream:
 * • `cx` is imported rather than defined inline (upstream is one big file).
 * • No `import React` — this app uses the automatic JSX runtime and Icon has no
 *   hooks, so the import would only trip eslint's no-unused-vars.
 * • Upstream defaults `color` to `currentColor` and always writes it inline. On the
 *   CSS `color` property that resolves to the inherited colour, so the inline style
 *   wins over a caller's `text-orange-500`/`text-ink-3` class. This port omits the
 *   inline declaration unless `color` is explicitly supplied; uncoloured icons still
 *   inherit naturally, while Tailwind colour utilities can now do their job.
 *
 * The Material Symbols stylesheet is NOT loaded here — it's a <link> in
 * public/index.html. (The older CSS-based DS injected it from JS; the Tailwind
 * library doesn't, so the <link> is now the only source.)
 */
import { cx } from "./cx";

export function Icon({
  name,
  size = 24,
  weight = 300,
  fill = false,
  color,
  grade = 0,
  style = {},
  className = "",
  ...rest
}) {
  const px = typeof size === "number" ? size : parseFloat(size) || 24;
  return (
    <span
      className={cx("dnd-icon", className)}
      aria-hidden="true"
      style={{
        fontFamily: "'Material Symbols Rounded'",
        fontWeight: "normal",
        fontStyle: "normal",
        fontSize: `${px}px`,
        lineHeight: 1,
        ...(color != null ? { color } : {}),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        flexShrink: 0,
        verticalAlign: "middle",
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${Math.min(48, Math.max(20, px))}`,
        ...style,
      }}
      {...rest}
    >
      {name}
    </span>
  );
}
